import { useI18n } from "vue-i18n";

const newDate = (datetime) => (datetime === "today" ? new Date() : new Date(datetime));

const toLocaleDateString = (datetime, format, locale = "en-EN") => {
  if (locale === "zh_Hans") {
    locale = "zh-CN";
  }

  return newDate(datetime).toLocaleDateString(locale, format);
};

export const formatISODate = (date) => {
  const d = new Date(date);

  const utc = new Date(0);
  utc.setUTCFullYear(d.getFullYear());
  utc.setUTCMonth(d.getMonth());
  utc.setUTCDate(d.getDate());

  return utc.toJSON().slice(0, 10);
};

export const todayISODate = formatISODate(new Date());

export const replaceToday = (str) => str.replace("TODAY", todayISODate);

export const formatDate = (datetime, locale = undefined) =>
  toLocaleDateString(
    datetime,
    {
      year: "numeric",
      month: "short",
      day: "numeric",
    },
    locale || i18n.global.locale.value
  );

export const formatMonth = (datetime, locale = undefined) =>
  toLocaleDateString(
    datetime,
    {
      month: "short",
      day: "numeric",
    },
    locale || i18n.global.locale.value
  );

export const formatMonthOnly = (datetime, locale = undefined) =>
  toLocaleDateString(
    datetime,
    {
      month: "short",
    },
    locale || i18n.global.locale.value
  );

export const formatDay = (datetime) => {
  const { t } = useI18n();
  const days = [t("Sunday"), t("Monday"), t("Tuesday"), t("Wednesday"), t("Thursday"), t("Friday"), t("Saturday")];
  const day = new Date(datetime).getDay();
  return days[day];
};

export const formatDays = (from, until) => {
  const s1 = formatDay(from);
  const s2 = formatDay(until);

  // Fri - Sun
  if (s1 !== s2) {
    return `${s1}—${s2}`;
  }

  // Sat
  return s1;
};

export const formatDates = (from, until) => {
  const fromDate = newDate(from);
  const untilDate = newDate(until);

  // Fallback: if one of the inputs is invalid, return the safest available representation.
  if (Number.isNaN(fromDate.getTime()) || Number.isNaN(untilDate.getTime())) {
    if (!Number.isNaN(fromDate.getTime()) && !Number.isNaN(untilDate.getTime())) {
      return `${formatDate(from)} — ${formatDate(until)}`;
    }
    if (!Number.isNaN(fromDate.getTime())) {
      return formatDate(from);
    }
    if (!Number.isNaN(untilDate.getTime())) {
      return formatDate(until);
    }
    return "";
  }

  const y1 = fromDate.getFullYear();
  const y2 = untilDate.getFullYear();
  const m1 = fromDate.getMonth();
  const m2 = untilDate.getMonth();
  const d1 = fromDate.getDate();
  const d2 = untilDate.getDate();
  let formatDateString = "";
  if (y1 !== y2) {
    // Dec 31, 2022 — Jan 1, 2023
    formatDateString = `${formatDate(from)} — ${formatDate(until)}`;
  } else if (m1 !== m2) {
    // Jan 1-Feb 1, 2023
    formatDateString = `${formatMonthOnly(from)} ${d1}—${formatDate(until)}`;
  } else if (d1 !== d2) {
    // Jan 1-2, 2023
    formatDateString = `${formatMonthOnly(from)} ${d1}—${d2}, ${y2}`;
  } else {
    // Jan 1, 2023
    formatDateString = formatDate(from);
  }
  return formatDateString.charAt(0).toUpperCase() + formatDateString.slice(1);
};

// @todo verify
export const formatTime = (datetime) => (datetime.substr(11, 5) === "00:00" ? "" : datetime.substr(11, 5));

import __slugify from "slugify";
import { i18n } from "@/i18n.ts";
export const slugify = (str) => __slugify(str, { lower: true, strict: true });

export const formatEuros = (cents) => "€" + (cents / 100).toFixed(2);

export const capitalize = (str) => str.replace(/[a-z]/i, (ch) => ch.toUpperCase());

export const formatWithOffset = (datetime) => {
  const dt = new Date(datetime);
  let timeOffsetInMS = dt.getTimezoneOffset() * 60000;
  dt.setTime(dt.getTime() - timeOffsetInMS);
  return dt.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
};
import { isoCountry2 as countries } from "@xs2event/js-lib";

export const iso3ToIso2 = (iso3) => {
  return countries.find((c) => c.code3 === iso3)?.code;
};

export function formatDateOfBirth(dateOfBirthISO) {
  console.log(dateOfBirthISO);
  const dateOfBirth = new Date(dateOfBirthISO);
  return `${dateOfBirth.getFullYear()}-${String(dateOfBirth.getMonth() + 1).padStart(2, "0")}-${String(dateOfBirth.getDate()).padStart(2, "0")}`;
}
